@import "../../theme/global";

.details {
  padding: 3rem 0 0 0;
  lar-button-group {
    align-items: center;
    justify-content: center;
  }
}

.actions {
  min-height: 60px
}

lar-list-item {
  background-color: $background-color-step-100 !important;
  color: $text-color !important;
}
.spacer {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.circle {
  background-color: $background-color-step-200 !important;
  border-radius: 50%;
  display: inline-block;
  padding: .5rem;
  width: 2rem;
  height: 2rem;
  margin-right: 1rem;
}

.circle lar-icon {
  display: block;
  width: 100%;
  height: 100%;
}

.zone-list {
  h4 {
    margin: 0;
    padding: 0;

    lar-badge {
      margin-top: .2rem;
      margin-right: .3rem;
      font-weight: normal;
    }
  }
}

.zone-selectors {
  text-align: center;
  margin-bottom: 1rem;
  lar-button {
    margin: .2rem;
  }
}

.zone-list {
  lar-badge {
    margin-top: .3rem;
  }
}
lar-button.zone-group {
  --lar-button-font-size-small: .95rem;
  --lar-button-padding-top-small: .4rem;
  --lar-button-padding-bottom-small: .4rem;
  --lar-button-padding-left-small: .4rem;
  --lar-button-padding-right-small: .4rem;
}

.center {
  text-align: center;
}